import React from 'react';
import { PropTypes } from 'prop-types'
import classnames from 'classnames';
import 'moment/locale/fr';
import DateTime from '../library/common/DateTime';

const DateLabelledField = (props) => (
    <div>
        <div className={classnames({
            'columnLabel': props.alignment === 'columnLabel',
            'row': props.alignment !== 'columnLabel',

        })} >
            <label className={classnames('label', {
                'col-4': props.alignment === 'columnLabel',
                'col-6': props.alignment === 'leftLabel',
                'col-7': props.alignment === 'leftLabelTight',
                'col-1': !['columnLabel', 'leftLabel', 'leftLabelTight'].includes(props.alignment)
            })} >
                {props.label}
            </label>
            <span className={classnames({
                'col-5': props.alignment === 'columnLabel',
                'col-6': props.alignment === 'leftLabel',
                'col-7': props.alignment === 'leftLabelTight',
                'col-2': !['columnLabel', 'leftLabel', 'leftLabelTight'].includes(props.alignment)
            })}>
                {!props.text &&
                    <span>-</span>
                }
                {props.text && 
                    <DateTime value={props.text} fallbackValue='-' dateAndTime={!props.shortDate} boldValue={props.boldText}></DateTime>
                }
            </span>            
        </div>
    </div>
);

DateLabelledField.propTypes = {
    label: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    alignment: PropTypes.string,
    shortDate: PropTypes.bool,
    boldText: PropTypes.bool
}

export default DateLabelledField;